module.exports = __webpack_public_path__ + "static/media/simplebg01.33ffebec.jpg";